import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "./assets/bg1.png"


const AdditionalActivity = ({ userId }) => {
  const [inIndia, setInIndia] = useState(false);
  const [abroad, setAbroad] = useState(false);

  const handleInIndiaChange = (e) => {
    setInIndia(e.target.value === "yes");
  };

  const handleAbroadChange = (e) => {
    setAbroad(e.target.value === "yes");
  };

  const schema = yup.object().shape({
    Physical_Disabilities: yup
      .string()
      .required("Physical Disabilities is required"),
    Marital_Indebtness: yup.string().required("Marital Indebtness is required"),
    Languages_Known: yup.string().required("Languages Known is required"),
    Hobbies: yup.string().required("Hobbies is required"),
    Three_Strengths: yup.string().required("Your Three Strengths is required"),
    three_Weaknesses: yup
      .string()
      .required("Your three Weaknesses is required"),
    In_India: yup
      .string()
      .required("Please specify if willing to travel in India"),
    Abroad: yup.string().required("Please specify if willing to travel abroad"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found, please login again.");
    }
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found, please login again.");
      navigate("/SignInCandidate");
    }
  }, [navigate]);

  const onSubmit = async (formData) => {
    try {
      const finalObj = {...formData, userId}
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("user unauthorized.");
        return;
      }
      

      const response = await fetch(" http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/AdditionalInformation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        },
        body: JSON.stringify(finalObj),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();

      toast.success("Additional Information Submitted Successfully!", {
        position: "top-center",
        transition: Slide,
      });

      reset(); // Reset form after successful submission
      setTimeout(() => {
        navigate("/EnteryCandidatePortel/Emergency-Details");
      }, 2000); // 1 second delay
    } catch (error) {
      toast.error("Error submitting form. Please try again.");
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
    <div
    className="w-full flex items-center justify-center"
    style={{
      backgroundImage: `url(${bgImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
    }}
    >
      <ToastContainer transition={Slide} />
      <form onSubmit={handleSubmit(onSubmit)} className="max-w-4xl mx-auto p-6 md:p-10 bg-white shadow-lg rounded-lg">
      <h1 className="text-2xl md:text-3xl font-serif font-bold text-center mt-6 text-indigo-600">
        ADDITIONAL INFORMATION
      </h1>
      <div className="border-b-2 border-indigo-400 my-4 mx-auto w-11/12 md:w-2/3"></div>
        <div className="space-y-4">
          <span className="text-base md:text-lg font-serif font-bold text-black block mt-5">
            Do you have:
          </span>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Physical Disabilities */}
            <div className="flex flex-col">
              <span className="text-sm font-bold text-black">
                A. Physical Disabilities:
              </span>
              <label className="inline-flex items-center mt-2">
                <input
                  type="radio"
                  value="yes"
                  {...register("Physical_Disabilities")}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <span className="ml-2 text-xs md:text-sm font-serif font-bold">
                  Yes
                </span>
              </label>
              <label className="inline-flex items-center mt-2">
                <input
                  type="radio"
                  value="no"
                  {...register("Physical_Disabilities")}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <span className="ml-2 text-xs md:text-sm font-serif font-bold">
                  No
                </span>
              </label>
            </div>

            {/* Marital Indebtness */}
            <div className="flex flex-col">
              <span className="text-sm font-bold text-black">
                B. Marital Indebtedness:
              </span>
              <label className="inline-flex items-center mt-2">
                <input
                  type="radio"
                  value="yes"
                  {...register("Marital_Indebtness")}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <span className="ml-2 text-xs md:text-sm font-serif font-bold">
                  Yes
                </span>
              </label>
              <label className="inline-flex items-center mt-2">
                <input
                  type="radio"
                  value="no"
                  {...register("Marital_Indebtness")}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <span className="ml-2 text-xs md:text-sm font-serif font-bold">
                  No
                </span>
              </label>
            </div>

            {/* Court Proceedings */}
            <div className="flex flex-col">
              <span className="text-sm font-bold text-black">
                C. Involvement in Court Proceedings:
              </span>
              <label className="inline-flex items-center mt-2">
                <input
                  type="radio"
                  value="yes"
                  {...register("Been_involved_in_Court_Proceeding")}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <span className="ml-2 text-xs md:text-sm font-serif font-bold">
                  Yes
                </span>
              </label>
              <label className="inline-flex items-center mt-2">
                <input
                  type="radio"
                  value="no"
                  {...register("Been_involved_in_Court_Proceeding")}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <span className="ml-2 text-xs md:text-sm font-serif font-bold">
                  No
                </span>
              </label>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Languages Known */}
            <div>
              <label className="block text-sm md:text-base font-serif font-bold text-black mt-3">
                Languages Known:
              </label>
              <input
                type="text"
                placeholder="Your answer"
                {...register("Languages_Known")}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none ${
                  errors.Languages_Known
                    ? "border-red-500"
                    : "focus:border-indigo-500"
                }`}
              />
              {errors.Languages_Known && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.Languages_Known.message}
                </p>
              )}
            </div>

            {/* Hobbies */}
            <div>
              <label className="block text-sm md:text-base font-serif font-bold text-black mt-3">
                Your Hobbies:
              </label>
              <input
                type="text"
                placeholder="Your answer"
                {...register("Hobbies")}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none ${
                  errors.Hobbies ? "border-red-500" : "focus:border-indigo-500"
                }`}
              />
              {errors.Hobbies && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.Hobbies.message}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Weaknesses */}
            <div>
              <label className="block text-sm md:text-base font-serif font-bold text-black mt-3">
                Your Three Weaknesses:
              </label>
              <input
                type="text"
                placeholder="Your answer"
                {...register("three_Weaknesses")}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none ${
                  errors.three_Weaknesses
                    ? "border-red-500"
                    : "focus:border-indigo-500"
                }`}
              />
              {errors.three_Weaknesses && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.three_Weaknesses.message}
                </p>
              )}
            </div>

            {/* Strengths */}
            <div>
              <label className="block text-sm md:text-base font-serif font-bold text-black mt-3">
                Your Three Strengths:
              </label>
              <input
                type="text"
                placeholder="Your answer"
                {...register("Three_Strengths")}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none ${
                  errors.Three_Strengths
                    ? "border-red-500"
                    : "focus:border-indigo-500"
                }`}
              />
              {errors.Three_Strengths && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.Three_Strengths.message}
                </p>
              )}
            </div>
          </div>

          {/* Travel */}
          <div className="space-y-4">
            <h1 className="block text-sm md:text-base font-serif font-bold text-black mt-3">
              Are you willing to travel:
            </h1>

            {/* In India */}
            <div className="flex items-center">
              <label className="text-sm md:text-base font-serif font-bold text-black mr-2">
                In India:
              </label>
              <label className="inline-flex items-center text-xs md:text-sm font-serif font-bold">
                <input
                  type="radio"
                  value="yes"
                  {...register("In_India")}
                  checked={inIndia === true}
                  onChange={handleInIndiaChange}
                  className="mr-1"
                />
                Yes
              </label>
              <label className="inline-flex items-center ml-4 text-xs md:text-sm font-serif font-bold">
                <input
                  type="radio"
                  value="no"
                  {...register("In_India")}
                  checked={inIndia === false}
                  onChange={handleInIndiaChange}
                  className="mr-1"
                />
                No
              </label>
            </div>

            {/* Abroad */}
            <div className="flex items-center">
              <label className="text-sm md:text-base font-serif font-bold text-black mr-2">
                Abroad:
              </label>
              <label className="inline-flex items-center text-xs md:text-sm font-serif font-bold">
                <input
                  type="radio"
                  {...register("Abroad")}
                  value="yes"
                  checked={abroad === true}
                  onChange={handleAbroadChange}
                  className="mr-1"
                />
                Yes
              </label>
              <label className="inline-flex items-center ml-4 text-xs md:text-sm font-serif font-bold">
                <input
                  type="radio"
                  value="no"
                  {...register("Abroad")}
                  checked={abroad === false}
                  onChange={handleAbroadChange}
                  className="mr-1"
                />
                No
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <div className="w-full flex justify-center mt-6">
            <button
              type="submit"
              className="bg-indigo-600 text-white font-bold py-2 px-6 rounded-md hover:bg-indigo-700 transition duration-300"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
      </div>
    </>
  );
};

export default AdditionalActivity;
